import React, { Component } from "react";
import Data from "../config/data";
import ScrollView from "./ScrollView";
import Content from "./Content";

export default class VipServicePage extends Component {

    render() {
        const data = Data.VIPAgreement;
        return (<ScrollView>
            <Content data={data} />
        </ScrollView>);
    }
}


// WEBPACK FOOTER //
// ./src/component/vipservicepage.js